export default __webpack_public_path__ + "static/media/group-set2.9a0294e5.svg";